import React from 'react';

const SectionHeader = ({ title, right }) => {
  return (
    <div className="flex items-center justify-between mb-4 md:mb-6">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground">{title}</h2>
      {right}
    </div>
  );
};

export default SectionHeader;
